export const FULL_ROUTES_PATH = {
  HOME: {
    index: "/home",
  },
  SIGN_IN: {
    index: "/login",
  },
  VERIFY_OTP: {
    index: "/verify-otp",
  },
  RESET_PASSWORD: {
    ResetPassword: "/reset-password",
  },
  FORGET_PASSWORD: {
    forgetPassword: "/forget-password",
  },
  ONBOARDING: {
    index: "/onboarding",
  },
  TRADER: {
    index: "/trader",
  },
  TEAM_RUN_READONLY: {
    index: "/team-run-read-only",
  },
  AUDIT_TRAIL: {
    index: "/audit-trail",
    auditDetails: "/audit-trail/:id",
  },
  PRICER: {
    newPricer: "/new-pricer",
    index: "/pricer",
  },
  TEAM_RUN: {
    index: "/team-run",
  },
  VOL_SURFACE: {
    index: "/vol-surface",
  },
  VOL_SURFACE_Data: {
    index: "/vol-surface-data",
  },
  MARKET_ANALYSIS: {
    index: "/market-analysis",
  },
  BUSINESS_ANALYTICS: {
    index: "/business-analytics",
  },
  TESTING: {
    index: "/testing",
  },
  PROFILE: {
    index: "/profile",
  },
  CHAT: {
    index: "/chat",
  },
  TRADE_CONFIRM: {
    index: "/trade-confirmation",
  },
  PAYOUT_ANALYSIS_SHARE: {
    // Public 6-digit share page. Time Series uses ?kind=time-series;
    // Matrix uses ?kind=matrix; bulk P&L compare uses ?kind=payout-compare;
    // payout analysis is bare /:token.
    index: "/:token",
  },
  MATRIX_SHARE: {
    // Legacy path — redirects to /:token so guests are not sent to login.
    index: "/matrix/:token",
  },
  ERROR: {
    500: "/internal-error",
    404: "/page-not-found",
    403: "/unexpected-error",
  },
};
